export default __webpack_public_path__ + "images/102d1a60d3fca95736f8f51be4484ee3.svg";